<template>
    <select class="form-control font-weight-bold"  id="selecComision" v-model="valor"  @change="$emit('evento', valor)">
        <option v-if="todo" value="Todo">Todo</option>
        <option v-if="todo==undefined" value="">Seleccione Local...</option>
        <option v-for="d in $store.state.dataLocales" :key="d.Id" :value="d.Id"  >{{d.ciudad +'_______'+d.jiron+' - '+d.detalle_jiron }}</option>
    </select>
</template>

<script>
export default {
    name:"SelectLocales",
    props:['valor_entrada','todo'],
     data(){
        return{
            valor:'',
            data:[]
            }
        },
         beforeMount() {
           setTimeout(() => {

                this.valor = this.valor_entrada;
            }, 100);
        },
        watch: {
           
            valor_entrada(newQuestion, oldQuestion) {
                this.valor=newQuestion;
                
            }
        }

}
</script>

